<template>
  <div class="login">
    <el-card class="box-card" shadow="always">
      <div slot="header" class="title">
        <span>KOPA金邦云平台</span>
        <!-- 车辆电池告警平台 -->
      </div>
      <el-form
        :model="loginForm"
        ref="loginForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="账号"
          prop="loginName"
          :rules="[{ required: true, message: '请输入账号' }]"
        >
          <el-input v-model="loginForm.loginName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码' }]"
        >
          <el-input
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="记住密码" prop="password">
          <el-switch v-model="loginForm.remember"> </el-switch>
        </el-form-item>
        <div class="btns">
          <el-button
            type="success"
            v-on:click="submitForm"
            v-loading.fullscreen.lock="fullscreenLoading"
            >登录系统</el-button
          >
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { CAPTCHA_HOST } from "@/utils/host";

export default {
  name: "Login",
  data() {
    return {
      fullscreenLoading: false,
      loginForm: {
        loginName: "",
        password: "",
        remember: false
      }
    };
  },
  computed: {},
  beforeMount() {
    const rememberPwd = localStorage.getItem("rememberPwd");
    if (rememberPwd == "true") {
      this.loginForm.remember = true;
      const loginName = localStorage.getItem("loginName");
      const password = localStorage.getItem("password");
      this.loginForm.loginName = loginName;
      this.loginForm.password = password;
    } else {
      this.loginForm.remember = false;
    }
  },
  methods: {
    submitForm() {
      localStorage.setItem("rememberPwd", this.loginForm.remember);
      if (this.loginForm.remember) {
        localStorage.setItem("loginName", this.loginForm.loginName);
        localStorage.setItem("password", this.loginForm.password);
      }
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          this.$store.dispatch("login/login", this.loginForm);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "./Login.less";
.login {
  background: url(../../static/image/login.jpg);
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue